import { ADMIN, ANONYMOUS, USER } from 'constants/roles.constant'
import { useSelector } from 'react-redux'
import adminNavConfig from './admin'
import userNavConfig from './user'

const NavigationConfig = () => {
    const userAuthority = useSelector((state) => state.auth.user.authority)

    let navigationConfig = []

    if (userAuthority.includes(ADMIN)) {
        navigationConfig = adminNavConfig
    } else if (userAuthority.includes(USER) || userAuthority.includes(ANONYMOUS)) {
        navigationConfig = userNavConfig
    }

    return navigationConfig
}

export default NavigationConfig
